import { UtenteVO } from "../utenteVO";
import { DocumentoVO } from "../documentoVO";
import { MetadatiCorrispondenzaArrivoVO } from "./metadati-corrispondenza-arrivoVO";

export class AttribuzioneVO {
  id: string;
  idCorrispondenza: string;
  estensore: UtenteVO;
  metadatiCorrispondenzaArrivo: MetadatiCorrispondenzaArrivoVO;
  dataAttribuzione: number;
  dataPresaVisione: number;
  dataEsito: number;
  stato: string;
  motivoRifiuto: string;
  primario: DocumentoVO;
  allegati: DocumentoVO[];
}
